import { render, staticRenderFns } from "./DiagnosticModal.vue?vue&type=template&id=3958351b&"
import script from "./DiagnosticModal.vue?vue&type=script&lang=js&"
export * from "./DiagnosticModal.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosticModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports